//WE.Flow.Html.Contracts.Manifests.ProductConfigWE

export class ProductConfigWE {
    name: string = "";
    description: string = "";
    impersonation: string = "";
    payload: string = "";
    hideChange: boolean = false;
}
